export default "__VITE_ASSET__baac085d__"